import { defineStore } from "pinia";
import Cookies from "js-cookie";
import { LOGIN } from "@/shared/resource/apis/endpoints";
import { api } from "@/shared/resource/apis/baseApi";

export const useLoginStore = defineStore("login", {
  state: () => ({
    loginDetails: null,
    accessToken: null,
    refreshToken: null,
  }),

  actions: {
    async sendOTP(userType, phoneNumber) {
      const response = await api.post(`/${userType}${LOGIN.SEND_OTP}`, {
        phone_number: phoneNumber,
      });
      return response.data;
    },

    async verifyOTP(userType, adminId, OTPCode) {
      const response = await api.post(`/${userType}${LOGIN.VERIFY_OTP}`, {
        user_id: adminId,
        otp: OTPCode,
      });

      if (response?.data?.success || response?.data?.status) {
        const { accessToken, refreshToken, user } = response.data;
        this.setAccessToken(accessToken);
        this.setRefreshToken(refreshToken);
        this.setLoginDetails(user);
      }
      return response.data;
    },

    async validateAccessToken(userType) {
      const response = await api.get(
        `/${userType}${LOGIN.VALIDATE_ACCESS_TOKEN}`
      );
      return response.data;
    },

    async validateRefreshToken(userType) {
      const response = await api.post(
        `/${userType}${LOGIN.VALIDATE_REFRESH_TOKEN}`,
        {
          refresh_token: this.refreshToken,
        }
      );
      return response.data;
    },

    setLoginDetails(value) {
      this.loginDetails = value;
    },

    logout() {
      this.setLoginDetails(null);
      this.removeTokens();
    },

    setTokens() {
      this.accessToken = Cookies.get("accessToken");
      this.refreshToken = Cookies.get("refreshToken");
    },

    setAccessToken(token) {
      this.accessToken = token;
      Cookies.set("accessToken", token, {
        expires: 7,
        secure: true,
      });
    },

    setRefreshToken(token) {
      this.refreshToken = token;
      Cookies.set("refreshToken", token, {
        expires: 30,
        secure: true,
      });
    },

    removeTokens() {
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");

      this.accessToken = null;
      this.refreshToken = null;
    },
  },

  getters: {
    getLoginDetails: (state) => state.loginDetails,
    getAccessToken: (state) => state.accessToken,
    getRefreshToken: (state) => state.refreshToken,
  },
});
